import { fetchSmsPrices } from "@/api/smsService";

export default {
  //Fetch sent
  async fetchSmsPrices({ commit }) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await fetchSmsPrices();
      const sms = response.data.data;
      commit("SET_SMS_DATA", sms);
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },
};
